import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonIcon, IonLabel, IonList, IonMenuToggle, IonToolbar } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { AccountService } from '@okcargo-apps/shared-application-ionic';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { Observable } from 'rxjs';
import { LangSelectComponent } from '../../../account/application/lang-select/lang-select.component';
@Component({
  selector: 'app-menu-footer',
  templateUrl: './menu-footer.component.html',
  styleUrls: ['./menu-footer.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    LangSelectComponent,
    IonToolbar,
    IonList,
    IonMenuToggle,
    IonIcon,
    IonLabel,
  ],
})
export class MenuFooterComponent {
  private readonly accountService = inject(AccountService);

  public readonly userCapabilities$: Observable<ECapabilities[]> = this.accountService.userCapabilities$;
  public readonly ECapabilities = ECapabilities;
}
